// extracted by mini-css-extract-plugin
export default {"list-content__container":"styles_list-content__container__i4MT-"};